export const sources={};export const img={src:"__VITE_ASSET__HAwZnQ40A17rYC3Q$lxt9A__",w:640,h:640};export default{sources:sources,img:img};